import ButtonSlider from '@common_components/buttons/ButtonSlider';
import React, { ReactNode } from 'react';

interface SectorTabsProps {
  sectors: { id: string; name: string, icon?: ReactNode }[];
  onSectorClick: ( index: number ) => void;
  selectedIndex?: number;
}

const TabsSlider: React.FC<SectorTabsProps> = ( { sectors, onSectorClick, selectedIndex } ) => {
  return (
    <div className="flex w-full gap-x-4">
      {sectors.length > 0 ? (
        <ButtonSlider
          buttonItems={sectors}
          onButtonClick={index => {return onSectorClick( index );}}
          baseClassName="bg-white mb-4 shadow dark:bg-dark-bg-light w-full"
          textColor="text-gray-base-darkLight"
          sliderBg="bg-app-color-very-light"
          activeTextColor="text-app-color"
          selectedIndex={selectedIndex}
        />
      ) : null
      }
    </div>
  );
};

export default TabsSlider;
